import { millisecondsPer } from '@art-suite/art-core-ts';
import { createPersistentCacheContext } from '@kaiizen/react-persistent-cache';

export const SYNC_RECORD_MAX_AGE_MS = 90 * millisecondsPer.day;

export const {
  PersistentCacheProvider: SyncPersistenceProvider,
  usePersistentCache: useSyncPersistence,
} = createPersistentCacheContext('sync-persistence');
